var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"whitespace-pre-line mb-1 font-semibold avoid-page-break"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }